import { AES_CRYPTO_KEY_BITS, NONCE_RANDOM_BYTES, SALT_RANDOM_BYTES, } from '@lucidlink/ts-crypto/crypto';
import { calculateBase64Size } from '@lucidlink/ts-crypto/utils';
export { AES_CRYPTO_BLOCK_SIZE_BITS, AES_CRYPTO_IV_LENGTH, AES_CRYPTO_KEY_BITS, digestOutput, NONCE_RANDOM_BYTES, SALT_RANDOM_BYTES, } from '@lucidlink/ts-crypto/crypto';
export const SALT_BASE64_LENGTH = calculateBase64Size(SALT_RANDOM_BYTES);
export const NONCE_BASE64_LENGTH = calculateBase64Size(NONCE_RANDOM_BYTES);
// wrapped crypto key has 8 bytes padding;
export const WRAPPED_AES_CRYPTO_KEY_BYTES = AES_CRYPTO_KEY_BITS / 8 + 8;
export const WRAPPED_AES_CRYPTO_KEY_BASE64_LENGTH = calculateBase64Size(WRAPPED_AES_CRYPTO_KEY_BYTES);
